import React, { Component } from 'react'
import PropTypes from 'prop-types'

class RiderTableCreateModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      title: "",
      errorMessage: ""
    }
  }

  addNewRider(e) {
    e.preventDefault()

    if (this.state.title) {
      this.props.createRiderTable(this.state.title)
      this.props.setModal(false)

      this.setState({title: "", errorMessage: ""})
    } else {
      this.setState({errorMessage: "Please insert title"})
    }
  }

  render() {
    return (
      <div className="modal-content">
        <form onSubmit={this.addNewRider.bind(this)}>
          <ul className="group" data-error-msg={this.state.errorMessage}>
            <li>
              <span className="unit" data-title="Table's title">
                <input
                  type="text"
                  value={this.state.title}
                  onChange={(e) => this.setState({title: e.target.value})} />
              </span>
            </li>
          </ul>

          <button type="submit">Add new table</button>
        </form>
      </div>
    )
  }
}

RiderTableCreateModal.propTypes = {
  createRiderTable: PropTypes.func,
  setModal: PropTypes.func
}

RiderTableCreateModal.defaultProps = {
  createRiderTable: function() {},
  setModal: function() {}
}

export default RiderTableCreateModal



// WEBPACK FOOTER //
// ./src/components/modals/rider-table-create-modal.js